module.exports = __webpack_public_path__ + "media/images/result_sets/circles/6r7r9r3n-f9aa771366e0ceb6490040c6509501ed.svg";